import React, { useState } from "react";
import { Wand2, ArrowUpRight, Sparkles } from "lucide-react";

/* This month's featured software — a tasteful, non-invasive promo band.
   Swap the whole feature in seconds by editing FEATURED below. */
const FEATURED = {
  name: "Customize Studio",
  kicker: "This month's featured software for sales teams",
  blurb:
    "Snap a photo of the home and instantly show a photorealistic before-and-after of the finished project — right at the kitchen table. When customers can see it, saying yes gets easy.",
  points: ["Roofing", "Showers", "Kitchens", "Siding", "Windows", "& more"],
  url: "https://customizestudio.com",
  cta: "See Customize Studio",
  image: "/customize-studio.png", // drop your upload at /app/frontend/public/customize-studio.png
};

export default function FeaturedSoftware() {
  const [hasImg, setHasImg] = useState(true);
  const f = FEATURED;
  return (
    <section className="px-4 sm:px-6 py-6" data-testid="featured-software">
      <div className="max-w-5xl mx-auto rounded-3xl overflow-hidden border border-white/10 bg-gradient-to-br from-[#101a30] via-[#0e1626] to-[#0b1220] shadow-[0_20px_60px_-30px_rgba(0,0,0,0.8)]"
        data-testid="featured-software-card">
        <div className="grid md:grid-cols-[1.15fr_1fr] items-stretch">
          {/* Copy */}
          <div className="p-6 sm:p-8">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-emerald-300">
              <Sparkles className="w-3.5 h-3.5" /> {f.kicker}
            </span>
            <h3 className="mt-3 text-2xl sm:text-3xl font-black tracking-tight text-white">{f.name}</h3>
            <p className="mt-2.5 text-slate-300 text-sm sm:text-[15px] leading-relaxed">{f.blurb}</p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {f.points.map((p) => (
                <span key={p} className="text-[11px] font-semibold text-slate-300 bg-white/5 border border-white/10 rounded-full px-2.5 py-1">{p}</span>
              ))}
            </div>
            <a href={f.url} target="_blank" rel="noopener noreferrer" data-testid="featured-software-cta"
              className="group inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full font-bold text-slate-950 bg-emerald-400 hover:bg-emerald-300 transition-colors">
              {f.cta}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          {/* Visual */}
          <div className="relative min-h-[180px] md:min-h-full bg-slate-900/60">
            {hasImg ? (
              <img src={f.image} alt={`${f.name} — AI before and after`} onError={() => setHasImg(false)}
                className="absolute inset-0 w-full h-full object-cover" />
            ) : (
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-emerald-500/15 to-violet-500/10">
                <span className="w-16 h-16 rounded-2xl flex items-center justify-center bg-emerald-400 text-slate-950"><Wand2 className="w-8 h-8" /></span>
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-200/80">AI before &amp; after</span>
              </div>
            )}
            <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(90deg, rgba(11,18,32,0.55), transparent 30%)" }} />
          </div>
        </div>
      </div>
    </section>
  );
}
